import React from 'react';
import './css/Privacy.css';

function Privacy() {
  return (
    <div className="privacy">
      <h2>Privacy Policy</h2>

      <p>
        At VyralMining, your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal information.
      </p>

      <h3>Information Collection</h3>
      <p>
        We collect Bitcoin wallet addresses and basic user information necessary to provide our mining services and process payouts.
      </p>

      <h3>Use of Information</h3>
      <p>
        Your information is used solely for operating our mining services, communicating with users, and complying with legal requirements.
      </p>

      <h3>Data Security</h3>
      <p>
        We implement industry-standard measures to safeguard your information against unauthorized access or disclosure.
      </p>

      <h3>Third-Party Sharing</h3>
      <p>
        We do not sell or rent your personal data. We may share data with trusted service providers strictly to support our operations.
      </p>

      <h3>Cookies and Tracking</h3>
      <p>
        Our website uses cookies to improve user experience. You can control cookie settings through your browser.
      </p>

      <h3>Policy Updates</h3>
      <p>
        This Privacy Policy may be updated periodically. Continued use of our services indicates acceptance of any changes.
      </p>

      <h3>Contact Us</h3>
      <p>
        For privacy questions or requests, please email support@vyralmining.com.
      </p>
    </div>
  );
}

export default Privacy;